var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "add-new-applicant" },
    [
      _c(
        "b-row",
        [
          _c("b-col"),
          _c(
            "b-col",
            { attrs: { sm: "6" } },
            [
              _c(
                "b-input-group",
                [
                  _c("b-form-input", {
                    attrs: { placeholder: "Example: G1234567A" },
                    model: {
                      value: _vm.nricFin,
                      callback: function($$v) {
                        _vm.nricFin = typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "nricFin"
                    }
                  }),
                  _c(
                    "b-input-group-append",
                    [
                      _c(
                        "b-btn",
                        {
                          attrs: { variant: "outline-success" },
                          on: {
                            click: function($event) {
                              _vm.addApplicant()
                            }
                          }
                        },
                        [_vm._v("Add Applicant")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("b-col")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-69d6156a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69d6156a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/bookModuleSession/AddApplicant.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-69d6156a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/mainPage/bookModuleSession/AddApplicant.vue
// module chunks = 8 13